import { createContext } from 'react';
import type { PermissionKey } from '../../lib/rbac/permissions.generated';
import type { CanOptions, EffectivePermissions } from '../../lib/rbac/permissions';

/**
 * - `loading`: Rechte werden geladen — nichts anzeigen, nichts umleiten.
 * - `ready`: Rechte liegen vor.
 * - `error` / `anonymous`: keine Rechte bekannt — alles ausgeblendet (Default Deny).
 */
export type PermissionStatus = 'loading' | 'ready' | 'error' | 'anonymous';

export interface PermissionContextValue {
  status: PermissionStatus;
  permissions: EffectivePermissions;
  can: (key: PermissionKey, options?: CanOptions) => boolean;
  canAny: (keys: readonly PermissionKey[], options?: CanOptions) => boolean;
  refresh: () => Promise<void>;
}

export const PermissionContext = createContext<PermissionContextValue | undefined>(undefined);
